import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@cmsgov/design-system-core";
import { summarizeFilterSelections } from "../services/Filters";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface Props {
  filterPanelDetailSectionName: string;
  filterName: string;
  currentFilterSelection: string[];
  onClick: (sectionName: string) => void;
  selectedReport: string;
}

function DrillableFilterLink({
  filterPanelDetailSectionName,
  filterName,
  currentFilterSelection,
  onClick,
  selectedReport,
}: Props) {
  // map internal click to fire onClick from props
  const clicked = () => onClick(filterName);
  const printStates = summarizeFilterSelections(
    filterName,
    currentFilterSelection,
    null,
  );

  const sisToolTip = "State-level institution count is unavailable.";
  // Two DIV tags being returned - second one is for print stylesheets.

  const filterLinkProperties =
    selectedReport === "SIS"
      ? {
          title: sisToolTip,
          disabled: true,
          icon: "question-circle",
          className: "disabled",
          id: "tooltipButton",
        }
      : {
          title: "",
          disabled: false,
          icon: "angle-right",
          className: "",
        };

  return (
    <div>
      <li
        key={filterPanelDetailSectionName}
        className={`printDark ds-c-label subsection-title locations screenOnly ${filterLinkProperties.className}`}
      >
        <Button
          disabled={filterLinkProperties.disabled}
          onClick={clicked}
          id={`drill_to_${filterName}_btn`}
          className={`activeDrillToStates subsectionButton ds-u-font-weight--bold ds-c-button--transparent ds-u-padding-right--0 ds-u-padding-left--0 ds-u-padding-bottom--1 ds-u-text-align--left ${
            filterLinkProperties.disabled === false ? "ds-u-color--base" : ""
          }`}
        >
          {filterPanelDetailSectionName}
        </Button>
        <span
          tabIndex={filterLinkProperties.disabled ? 0 : -1}
          id={filterLinkProperties.id}
          data-title={filterLinkProperties.title}
        >
          <FontAwesomeIcon
            icon={filterLinkProperties.icon as IconProp}
            className="far ds-u-float--right"
          />
        </span>
      </li>
      <div className="printOnly">
        <h4 className="ds-u-color--primary">{filterPanelDetailSectionName}</h4>
        {printStates}
      </div>
    </div>
  );
}

export default DrillableFilterLink;
